import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_ORIGIN } from '../config/env';
import * as s from './publicAuthStyles';

// Auth Phase 2 (P2-B, ruling R11): the public forgot-password page. Renders
// OUTSIDE the app shell (no auth, no Layout — the ScanReceipt precedent) and
// uses raw fetch: nothing here may touch the session module or the API
// clients. The server always answers the same 200 whatever the identifier,
// and so does this page: the success line shows after every submit. The
// "no email on file" line is STATIC — always rendered, never a reaction to
// what was typed (no enumeration).
const FORGOT_MESSAGE = 'If an account with that email exists, a reset link is on its way.';

const ForgotPassword = () => {
  const [identifier, setIdentifier] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!identifier.trim() || busy) return;
    setBusy(true);
    try {
      await fetch(`${API_ORIGIN}/api/auth/forgot`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ identifier: identifier.trim() })
      });
    } catch (err) { /* the outcome is never shown — the line below is the same either way */ }
    setSent(true);
    setBusy(false);
  };

  return (
    <div style={s.page} data-testid="forgot-password">
      <div style={s.card}>
        <img src="/gvc-logo.png" alt="GVC School Bus" style={s.logo} />
        <h1 style={s.title}>Reset your password</h1>
        {sent ? (
          <p style={s.successText} role="status">{FORGOT_MESSAGE}</p>
        ) : (
          <>
            <p style={{ ...s.hint, textAlign: 'center' }}>Enter the email address on your account and we'll send you a link to set a new password.</p>
            <form onSubmit={submit}>
              <label style={s.label}>Email address
                <input style={s.input} type="text" value={identifier} onChange={(e) => setIdentifier(e.target.value)}
                  autoComplete="username" autoFocus disabled={busy} inputMode="email" />
              </label>
              <button type="submit" style={s.primary} disabled={busy || !identifier.trim()}>{busy ? 'Sending…' : 'Send reset link'}</button>
            </form>
          </>
        )}
        <Link to="/login" style={s.secondaryLink}>Back to sign in</Link>
        <p style={s.staticNote}>No email on file? Ask your administrator to reset your password.</p>
      </div>
    </div>
  );
};

export default ForgotPassword;
